<template>
    <div class="details-container">
        <ns-loader
            ref="ns-loader"
            :to-load="toLoad"
            :fetch-timer="5000"
            @dataFetched="onDataFetched"
        >
            <div slot="content">
                <div v-if="simulation">
                    <div
                        @click="$router.go(-1)"
                    >
                        <el-icon class="el-icon-back"></el-icon> Retour
                    </div>
                    <h2 class="table-title">
                        Stats global du moteur sur la période {{simulationStartDate}} au {{simulationEndDate}}
                    </h2>
                    <el-table
                        :data="simulation.global_stats"
                    >
                        <el-table-column
                            min-width="110"
                            prop="consumption_mwh"
                            label="Consommation (MWh)"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="nominal_working_power_kw"
                            label="Puissance moyenne (kW) en fctment"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="min_power_kw"
                            label="Puissance minimale (kW)"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="max_power_kw"
                            label="Puissance maximale (kW)"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="percent_0_25"
                            label="% de temps à ]0%;25%[ de Pn"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="percent_25_50"
                            label="% de temps à ]25%;50%[ de Pn"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="percent_50_75"
                            label="% de temps à ]50%;75%[ de Pn"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="percent_75_100"
                            label="% de temps à >75% de Pn"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="nb_starts"
                            label="Nombre démarrages"
                        >
                        </el-table-column>
                    </el-table>
                    <h2 class="table-title">
                        Stats global du moteur par jour
                    </h2>
                    <el-table
                        :data="simulation.daily_stats"
                    >
                        <el-table-column
                            min-width="110"
                            prop="date"
                            label="Date"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="consumption_mwh"
                            label="Consommation (MWh)"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="nominal_working_power_kw"
                            label="Puissance moyenne (kW) fonctionnement"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="min_power_kw"
                            label="Puissance minimale (kW)"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="max_power_kw"
                            label="Puissance maximale (kW)"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="working_time_hours"
                            label="Temps de fonctionnement (en heures)"
                        >
                        </el-table-column>
                        <el-table-column
                            min-width="110"
                            prop="nb_starts"
                            label="Nombre démarrages"
                        >
                        </el-table-column>
                    </el-table>
                    <AssetDetails
                        v-if="simulation"
                        class="asset-details"
                        :simulation="simulation"
                    ></AssetDetails>
                    <EnergeticGains
                        v-if="simulation && isAdvanced"
                        :simulation="simulation"
                        @refresh-simulation="refreshSimulation"
                    ></EnergeticGains>
                </div>
            </div>
        </ns-loader>
    </div>
</template>

<script>
import NsLoader from 'fundation-app-vuejs/src/components/partials/ns-vue-loader';
import AssetDetails from './asset-details.vue';
import EnergeticGains from '@/components/partials/EnergeticGains/Index.vue'
import { mapGetters } from 'vuex';
export default {

    name: 'DetailsView',

    components:{
        NsLoader,
        AssetDetails,
        EnergeticGains
    },

    data () {
        return {
            simulation: null,

        };
    },

    computed:{
        ...mapGetters(['defaultDateFormat']),
        isAdvanced(){
            return this.$route.params.mode === 'advanced'
        },
        toLoad(){
            return [
                {
                    name: 'simulations',
                    model: 'simulations',
                    filters: {
                        archived: false,
                        is_latest: true,
                        motor_uid: this.$route.params.motorUid
                    }
                },
            ];
        },
        simulationStartDate(){
            return this.defaultDateFormat(this.simulation.start_date);
        },
        simulationEndDate(){
            return this.defaultDateFormat(this.simulation.end_date);
        },
    },

    methods:{
        onDataFetched (res){
            this.$set(this, 'simulation', res.simulations[0]);
        },
        refreshSimulation(){
            this.$refs['ns-loader'].triggerRefresh();
        }
    }
};
</script>

<style lang="scss">
.table-title{
    margin-top: 3rem;
    margin-bottom: 3rem;
}
.details-container{
    padding: 3rem 3rem;
}
.asset-details{
    margin-top: 3rem;
    max-height: none;
    height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Home/motors/simulations/details.vue